import React from 'react';
import Link from '@kyruus/link';
import { FormattedMessage } from '@kyruus/intl';
import { getGoogleMapsLink } from './utils';
import { object } from 'prop-types';
import { messages } from '../../lib/messages';

function GoogleMapsLink({ name, address }) {
  const link = getGoogleMapsLink(name, address);

  return (
    <Link href={link} target={'_blank'}>
      (<FormattedMessage {...messages.maplink} />)
    </Link>
  );
}

GoogleMapsLink.propTypes = {
  address: object.isRequired
};

export default GoogleMapsLink;
